import * as React from 'react';
import ReactJson from 'react-json-view';
import {BaseComponent} from '../components/';
import * as Dati from '../Dati';
import * as Glob from '../Globale';


interface ICampoJSONProps extends Dati.IBaseProps {
    Valore: Glob.DatiJSON;
}

export class CampoJSON extends BaseComponent<ICampoJSONProps, {}> {

    private _CSS: string = "form-control";
    private _Valore: Glob.DatiJSON = "{}";

    public constructor(props: any) {
        super(props);
        this.OnChange = this.OnChange.bind(this);
    }


    private Inizializza() {
        this._CSS = this.props.CSS == undefined ? "form-control" : this.props.CSS;
        if (this._Valore == "{}" && this.props.Valore != "{}") {
            this._Valore = this.props.Valore;
        }
    }

    private IsJSONString(json: string): boolean {
        try {
            JSON.parse(json);
        } catch (e) {
            return false;
        }
        return true;
    }

    private OnAggiornaJSON(valore: any) {
        this._Valore = JSON.stringify(valore.updated_src);
        this.props.OnChange(this.props.Name, JSON.stringify(valore.updated_src));
    }

    protected OnChange(e: React.FormEvent<any>): void {

        this._Valore = e.currentTarget.value;
        if (this.IsJSONString(this._Valore)) {
            this.props.OnChange(this.props.Name, this._Valore);
        } else {
            this.forceUpdate();
        }
    }

    private CambiaColore(): string {

        if ((this.IsJSONString(this._Valore)) == false) {
            this._CSS = this._CSS.concat(" TestoRosso")
        }
        return this._CSS;
    }


    public render() {
        this.Inizializza();

        return <div className="form-group kt-form login-form__group row">
            <div className={Glob.DimensioneCSS(3)}>
                <ReactJson src={JSON.parse(this.props.Valore)} onAdd={(v) => this.OnAggiornaJSON(v)}
                           onEdit={(v) => this.OnAggiornaJSON(v)}
                           onDelete={(v) => this.OnAggiornaJSON(v)}/>
            </div>
            <div className={"kt-input-icon kt-input-icon--right " + Glob.DimensioneCSS(9)}>
                <textarea name={this.props.Name} value={this._Valore} id={this.props.Name}
                          onChange={(e) => {
                              this.OnChange(e)
                          }} className={this.CambiaColore()} rows={4}/>
            </div>
        </div>;

    }
}



// WEBPACK FOOTER //
// ./src/components/CampoJSON.tsx